export const nullishSet = new Set(["null", "undefined", "NaN", ""]);

export const nullable = <Value>(value: Value): Value | null => {
  if (nullishSet.has(value as unknown as string)) {
    return null;
  }
  return value;
};
